var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapIconEndPoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: 22.5,
    rx: 7,
    ry: 3.5,
    fill: "#004273"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.125C13.3595 7.12686 11.7868 7.77935 10.6268 8.93933C9.46685 10.0993 8.81436 11.672 8.8125 13.3125C8.8125 18.607 14.4375 22.6057 14.6773 22.773C14.7718 22.8393 14.8845 22.8748 15 22.8748C15.1155 22.8748 15.2282 22.8393 15.3227 22.773C15.5625 22.6057 21.1875 18.607 21.1875 13.3125C21.1856 11.672 20.5331 10.0993 19.3732 8.93933C18.2132 7.77935 16.6405 7.12686 15 7.125ZM15 11.0625C15.445 11.0625 15.88 11.1945 16.25 11.4417C16.62 11.6889 16.9084 12.0403 17.0787 12.4515C17.249 12.8626 17.2936 13.315 17.2068 13.7515C17.12 14.1879 16.9057 14.5888 16.591 14.9035C16.2763 15.2182 15.8754 15.4325 15.439 15.5193C15.0025 15.6061 14.5501 15.5615 14.139 15.3912C13.7278 15.2209 13.3764 14.9325 13.1292 14.5625C12.882 14.1925 12.75 13.7575 12.75 13.3125C12.75 12.7158 12.9871 12.1435 13.409 11.7215C13.831 11.2996 14.4033 11.0625 15 11.0625Z",
    fill: "#36A6CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconEndPoint);
export default __webpack_public_path__ + "static/media/mapIconEndPoint.109ceea2a73beb6bed4e095a04ab36d1.svg";
export { ForwardRef as ReactComponent };